import LoadingScreen from 'components/LoadingScreen';
import PageLayout from 'components/PageLayout';
import ActiveFiltersBar from 'components/SearchAndFilters/SelectedFiltersBar';
import { useAtomValue, useSetAtom } from 'jotai';
import React, { Suspense } from 'react';
import { Row, Col, CardTitle } from 'reactstrap';
import DashboardActions from './DashboardActions';
import Filters from './Filters';
import { useFilterConfig } from './Filters.config';
import RepoInsights from './RepoInsights';
import RepositoryDataGrid from './RepositoryDataGrid';
import {
  filterValuesAtom,
  repositoriesDataAtom,
  useOnFilterChangeResetAtoms,
} from './state';
import StatusUpdater from './StatusUpdater';

const SelectedFilters: React.FC<{ filtersConfig }> = ({ filtersConfig }) => {
  const setFilterValues = useSetAtom(filterValuesAtom);
  const resetOnFilterChangeAtoms = useOnFilterChangeResetAtoms();

  return (
    <Suspense fallback={<></>}>
      <ActiveFiltersBar
        filtersConfig={filtersConfig}
        onFiltersReset={() => {
          setFilterValues({ ...filtersConfig.getActiveFilterValues() });
          resetOnFilterChangeAtoms();
        }}
      />
    </Suspense>
  );
};

const ListingCount: React.FC = () => {
  const listingData = useAtomValue(repositoriesDataAtom);
  return <>{listingData?.loading ? '...' : listingData.count}</>;
};

const RepositoryListing = () => {
  const filtersConfig = useFilterConfig();
  return (
    <PageLayout
      id="sast_repos_listing"
      heading={
        <Row>
          <Col md="auto" sm="12">
            <CardTitle>
              <h4>
                Repositories
                {/* {listingData?.count ? (
                  <label id="counts" className="label btn">
                    {' '}
                    {listingData?.count}
                  </label>
                ) : (
                  <></>
                )} */}
                <label id="counts" className="label btn">
                  <Suspense fallback={<>...</>}>
                    <ListingCount />
                  </Suspense>
                </label>
              </h4>
            </CardTitle>
          </Col>
        </Row>
      }
      description="List of all repositories/branches."
      // filteringOptions={<Filters />}
      filteringOptions={<Filters filtersConfig={filtersConfig} />}
    >
      <Suspense fallback={<LoadingScreen />}>
        <div className="container-fluid p-0">
          <div className="row mb-1">
            {/* Expanding Column */}
            <div className="col">
              <SelectedFilters filtersConfig={filtersConfig} />
            </div>

            {/* Fixed Column with Right-Aligned Content */}
            <div className="col-auto text-right align-baseline">
              <Suspense fallback={<></>}>
                <DashboardActions />
              </Suspense>
            </div>
          </div>
          <Suspense fallback={<LoadingScreen />}>
            <RepoInsights />
          </Suspense>

          <Suspense fallback={<LoadingScreen />}>
            <RepositoryDataGrid />
          </Suspense>
          <Suspense fallback={<></>}>
            <StatusUpdater />
          </Suspense>
          {/* {accountDetailsModal.open && (
            <AccountDetailModal
              accountId={accountDetailsModal.accountId}
              isOpen={accountDetailsModal.open}
              isActive={accountDetailsModal.isActive}
              isLoading={accountActionLoading}
              toggle={accountDetailsModal.toggle}
              handleActivateDeactivateAccount={handleActivateDeactivateAccount}
            />
          )} */}
        </div>
      </Suspense>
    </PageLayout>
  );
};

const RepositoryList: React.FC = () => {
  return (
    <Suspense fallback={<LoadingScreen height={550} />}>
      <RepositoryListing />
    </Suspense>
  );
};

export default RepositoryList;
